import React, { Component } from "react";

class Settings extends Component {
  render() {
    return (
      <div>
        Coming soon
      </div>
    );
  }
}

export default Settings;